module.exports = __webpack_public_path__ + "static/media/arrow-right.3f354bb5.svg";